import { useAssetSettings } from '@nsd/fe';
import { five9Integration } from 'src/constants/featureIdentifiers';
import isTruthyValue from 'src/utils/isTruthyValue';

export const isFive9IntegrationEnabledForAccess = ({
  envEnabled,
  featureEnabled
}) => envEnabled || featureEnabled;

/**
 * Resolves whether the Five9 integration is enabled for the current app state.
 */
export default function useFive9IntegrationEnabled() {
  const { hasFeatureAccess } = useAssetSettings();
  const envEnabled = isTruthyValue(process.env.REACT_APP_ENABLE_FIVE9);
  const featureEnabled = !!hasFeatureAccess(five9Integration);
  return isFive9IntegrationEnabledForAccess({ envEnabled, featureEnabled });
}
